import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NotificationsService } from '../../../services/notifications.service';
import { CmxLayoutService } from '../../../services/cmx-layout.service';
import { Direction } from '../../../types/directions';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Notification } from '../../../types/notification';

@Component({
  selector: 'cmx-notifications',
  templateUrl: './cmx-notifications.component.html',
  styleUrls: ['./cmx-notifications.component.scss', '../cmx-nav-header.component.scss'],
})
export class CmxNotificationsComponent implements OnInit, OnDestroy {
  @ViewChild('notificationsRef', { static: true })
  notificationsRef: ElementRef;

  direction: Direction;
  isNotificationsOpen = false;
  version = 2;
  countNotifications = 0;
  variant: string;
  renderNotificacionsContent = false;

  ngDestroyed = new Subject();
  private subscriptions: Subscription[] = [];
  public _serviceIcon: any = {
    S1: 'module-customer-information',
    S2: 'module-order-product-catalogue',
    S3: 'module-track',
    S4: 'module-invoices-payments',
    S5: 'module-user-management',
  };

  constructor(
    public notificationsService: NotificationsService,
    public layout: CmxLayoutService,
  ) {}

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.notificationsRef && !this.notificationsRef.nativeElement.contains(event.target)) {
      if (this.isNotificationsOpen) {
        this.toggleNotifications();
      }
    }
  }

  ngOnInit() {
    this.subscriptions.push(
      this.layout.version.subscribe((value) => (this.version = value)),
      this.notificationsService.notificationsCount.subscribe((value) => (this.countNotifications = value)),
      this.layout.direction.pipe(takeUntil(this.ngDestroyed)).subscribe((value) => (this.direction = value)),
      this.layout.variantHeader.subscribe((value) => (this.variant = value)),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.ngDestroyed.next();
    this.ngDestroyed.complete();
  }

  viewAllNotifications() {
    this.notificationsService.viewAllNotifications.next();
    this.isNotificationsOpen = false;
  }

  notificationItemClick(notification: Notification) {
    this.notificationsService.notificationItemClick.next(notification);
    this.isNotificationsOpen = false;
  }

  toggleNotifications() {
    this.renderNotificacionsContent = true;
    this.isNotificationsOpen = !this.isNotificationsOpen;
    this.notificationsService.notificationsDropdownOpen.next(this.isNotificationsOpen);
  }

  reload() {
    location.reload();
  }
}
